import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';
import { fetchCaseView, fetchCaseViewError, fetchCaseViewSuccess } from './actions';

import { DetailsCaseActionTypes } from './types';
import { getCaseView } from '../../utils/api/casesApi';
import { selectCase } from '../../../store/case';
import { fetchPolicyViewModel } from '../policy/actions';
import { fetchInsuredPerson } from '../insured-person/actions';
import { fetchExpertiseAttachments } from '../expertise-attachment/actions';
import { currentRoles } from '../shared/selectors';
import { Role } from '../../../store/shared/model';
import { fetchHonoraryNoteTypeCodes, fetchHonoraryNotes } from '../honorary-note/actions';
import { fetchImages } from '../images/actions';
import { fetchCommentOrReport, fetchDocumentTypes } from '../comment-or-report/actions';
import { resetDetailsRimState, fetchRimList } from '../rim/actions';
import { fetchAgenda } from '../agenda/actions';
import { fetchSvsList } from '../svs/actions';
import { getRimList, getSvsList, getDocumentList, getAskedAmount, getHonoraryNoteList } from '../overview/actions';
import { fetchOtherAttachments } from '../other-attachments/actions';
import { SagaIterator } from 'redux-saga';

function* handleFetchCaseView(action: ReturnType<typeof fetchCaseView>): SagaIterator {
  try {
    const res = yield call(getCaseView, action.payload.instructionId);

    if (!res.data) {
      yield put(fetchCaseViewError(res.response.data.code, res.response));
    } else {
      yield put(fetchCaseViewSuccess(res.data));
      yield put(selectCase(res.data.case));
      yield put(fetchPolicyViewModel(res.data.case.caseCode));
      yield put(fetchInsuredPerson(res.data.case.caseCode));
      yield put(fetchExpertiseAttachments(res.data.case.instructionId));
      const roles = yield select(currentRoles);

      yield put(fetchImages(res.data.case.instructionId));
      yield put(fetchCommentOrReport(res.data.case.instructionId));
      yield put(fetchOtherAttachments(res.data.case.instructionId));
      yield put(fetchDocumentTypes());
      yield put(resetDetailsRimState());
      yield put(fetchRimList(res.data.case.instructionId));
      yield put(fetchSvsList(res.data.case.instructionId));
      yield put(fetchAgenda(res.data.case.instructionId));

      yield put(getRimList(res.data.case.instructionId));
      yield put(getSvsList(res.data.case.instructionId));
      yield put(getDocumentList(res.data.case.instructionId));
      yield put(getAskedAmount(res.data.case.instructionId));

      if (roles.includes(Role.CrInIn)) {
        yield put(fetchHonoraryNoteTypeCodes());
        yield put(fetchHonoraryNotes(res.data.case.instructionId));
        yield put(getHonoraryNoteList(res.data.case.instructionId));
      }
     }
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchCaseViewError(err.name, `${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(fetchCaseViewError('handleFetchCaseView Saga', 'An unknown error occured.'));
    }
  }
}

function* watchCaseDetails() {
  yield takeEvery(DetailsCaseActionTypes.FETCH_CASE_VIEW, handleFetchCaseView);
}

function* detailsCaseSaga() {
  yield all([fork(watchCaseDetails)]);
}

export default detailsCaseSaga;
